import React from 'react';

import cn from 'classnames';

import { useAdminConversationForm } from '@entities/AdminConversationCategory/lib/hooks/useAdminConversationForm';
import { IForm } from '@entities/AdminConversationCategory/model/types';
import { Flex, Icon, UiButton, UiText, UITooltip } from '@shared/ui';

import cls from './AdminConversationForm.module.css';

interface AdminConversationFormProps {
    classes?: string;
    form: IForm;
    isFirst: boolean;
    isLast: boolean;
    onEditForm: (formId: number) => void;
    onShowPrev: (data: IForm) => void;
}

export const AdminConversationForm = ({
    classes,
    form,
    isLast,
    isFirst,
    onEditForm,
    onShowPrev,
}: AdminConversationFormProps) => {
    const { redirectToList, onSortForm, onDuplicateForm, onDeleteForm } =
        useAdminConversationForm(form);

    return (
        <div className={cn(cls.AdminConversationForm, [classes])}>
            <UiText classes={cls.title} variant="subHeading">
                {form.title}
            </UiText>
            <div className={cls.description}>
                <UITooltip label={form.privateDescription}>
                    <div className={cls.description}>
                        <UiText variant="plain">{form.privateDescription}</UiText>
                    </div>
                </UITooltip>
            </div>
            <UiButton
                btnColor="light"
                className={cls.sendButton}
                btnText="Отправка пользователям"
                onClick={redirectToList}
            />
            <Flex gap={8} className={cls.formInterface}>
                <UiButton
                    onClick={() => onSortForm('down')}
                    disabled={isLast}
                    variant="icon"
                    startIcon={<Icon iconName="arrowDown" />}
                    className={cls.InterfaceButton}
                />
                <UiButton
                    disabled={isFirst}
                    variant="icon"
                    onClick={() => onSortForm('up')}
                    startIcon={<Icon iconName="arrowUp" />}
                    className={cls.InterfaceButton}
                />
                <UiButton
                    onClick={() => onShowPrev(form)}
                    variant="icon"
                    startIcon={<Icon iconName="eye" />}
                    className={cls.InterfaceButton}
                />
                <UiButton
                    onClick={onDuplicateForm}
                    variant="icon"
                    startIcon={<Icon iconName="copy" fill="currentColor" />}
                    className={cls.InterfaceButton}
                />
                <UiButton
                    onClick={() => onEditForm(form.id)}
                    variant="icon"
                    startIcon={<Icon iconName="taskExecutorsEdit" fill="currentColor" />}
                    className={cls.InterfaceButton}
                />
                <UiButton
                    onClick={onDeleteForm}
                    variant="icon"
                    startIcon={<Icon iconName="filesDelete" />}
                    className={cls.InterfaceButton}
                />
            </Flex>
        </div>
    );
};
